import React from 'react'

export default function ColorStatus({text, style}) {
  return (
    <div className='colorStatus' style={style}>
      {text}
    </div>
  )
}
